import { forwardRef, type PropsWithChildren } from 'react';

import { Link } from '@/domains/core/routing/components/Link';
import { routes } from '@/domains/core/routing/routes/routes.default';
import { createURL } from '@/domains/core/routing/URLParser';

import { articlePathToSlugId } from '../../ProductPage/utils/productUrl/articlePathToSlugId';

export interface ProductCardLinkProps {
  /**
   * Trailing path for the final product URL.
   * Should **not** contain the subdirectory as it is added in this component.
   */
  url: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  favourite?: boolean;
}

export const ProductCardLink = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<ProductCardLinkProps>
>(({ children, url, className, onClick }, ref) => (
  <Link
    ref={ref}
    className={className}
    href={createURL(routes.product, articlePathToSlugId(url))}
    onClick={onClick}
  >
    {children}
  </Link>
));
